import { render, staticRenderFns } from "./PermanentJobsList.vue?vue&type=template&id=31c87092&scoped=true"
import script from "./PermanentJobsList.vue?vue&type=script&lang=ts"
export * from "./PermanentJobsList.vue?vue&type=script&lang=ts"
import style0 from "./PermanentJobsList.scss?vue&type=style&index=0&id=31c87092&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c87092",
  null
  
)

export default component.exports